import * as types from '../constants/actionTypes';

const initialState = {
  items: [],
  loading: true,
  users: {}
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.CREATE_BLOCKLIST_SUCCESS:
      return {
        ...state,
        items: action.payload,
        users: action.payload,
        loading: false
      };
    case types.SINGLE_BLOCKLIST_SUCCESS:
      return {
        ...state,
        items: action.payload,
        users: action.payload,
        loading: false
      };
    case types.UPDATE_BLOCKLIST_SUCCESS:
      return {
        ...state,
        items: action.payload,
        users: action.payload,
        loading: false
      };
    case types.DELETE_BLOCKLIST_SUCCESS:
      return {
        ...state,
        items: action.payload,
        users: action.payload,
        loading: false
      };
    default:
      return state;
  }
}
